module.exports = __webpack_public_path__ + "img/car_insurance.7b162ce9.png";